import Input from '@service-victoria/component-library/components/Input';
import RadioButton, {
  ItemType as RadiobuttonItem
} from '@service-victoria/component-library/components/RadioButton';
import Text from '@service-victoria/component-library/components/Text';
import { StepComponent } from '@service-victoria/component-library/components/Wizard/props';
import * as Interfaces from 'interfaces';
import React from 'react';
import { validatePreviousStep } from 'utils';
import * as Styled from '../styled';
import ProofTypePicker from './ProofTypePicker';

export const validProofTypes: RadiobuttonItem[] = [
  {
    label: 'Victorian driver licence or learner permit',
    value: 'driver_license'
  },
  {
    label: 'Victorian seniors card',
    value: 'seniorsCard'
  },
  {
    label: 'Victorian proof-of-age card',
    value: 'proofOfAgeCard'
  }
];

export type ComponentProps = StepComponent<Pick<Interfaces.Common.FormValues, 'identity'>>;

const Identity: React.FC<ComponentProps> = ({ context }) => {
  const {
    form: { values }
  } = context;

  React.useEffect(() => {
    validatePreviousStep('details', context);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Styled.Wrapper>
      <Text.Heading.H1 fontWeight={600}>Contact Details</Text.Heading.H1>
      <Styled.Spacer24 />
      <Input name='identity.email' label='Email' ariaLabel='Your e-mail address' />
      <Styled.Spacer24 />
      <Input
        name='identity.confirmEmail'
        label='Confirm email'
        ariaLabel='Confirm e-mail address'
      />
      <Styled.Spacer24 />
      <Input
        label='Mobile phone'
        name='identity.mobileNumber'
        hint='We may need to call  about your application'
      />
      <Styled.Spacer48 />
      <Text.Heading.H3 fontWeight={600}>I am a Victorian resident</Text.Heading.H3>
      <Text.Body>My proof (choose 1):</Text.Body>
      <RadioButton name='identity.proofType' groupLabel='' items={validProofTypes} />
      <Styled.Spacer24 />
      <ProofTypePicker identity={values.identity} />
      <Styled.Spacer48 />
    </Styled.Wrapper>
  );
};

export default Identity;
